export enum SocialPlatform {
    LINE = 'LINE',
    FACEBOOK = 'FACEBOOK',
    INSTAGRAM = 'INSTAGRAM',
    YOUTUBE = 'YOUTUBE',
    TWITTER = 'TWITTER',
    TIKTOK = 'TIKTOK'
}
